import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Breadcrumb from '@/components/feature/Breadcrumb';

const testimonials = [
  {
    name: '李女士',
    age: '32岁，宝宝2岁',
    content: '产后皮肤状态一度让我崩溃，暗沉、长斑、干燥，简直不敢照镜子。通过这个网站的抗衰保湿指南，我建立了自己的护肤流程，坚持了三个月，同事都说我气色好了很多。真心感谢！',
    rating: 5,
  },
  {
    name: '王小姐',
    age: '28岁，新妈妈',
    content: '孕期护肤指南对我帮助太大了！之前完全不知道哪些成分不能用，看了文章才明白。产后修复的内容也特别实用，孕期+产后护肤从此不再迷茫。',
    rating: 5,
  },
  {
    name: '张女士',
    age: '35岁，职场妈妈',
    content: '作为职场妈妈，时间特别紧张。这个网站推荐的早晚15分钟护肤法太实用了，不费时间但效果看得见。科学又接地气，不是那种华而不实的内容。',
    rating: 5,
  },
  {
    name: '赵女士',
    age: '30岁，宝宝1岁',
    content: '产后身材恢复一直是我的心结。这里的身材管理文章给了我科学的方法和合理的预期，不再被社交媒体的身材焦虑绑架。不急不躁，慢慢来，真的很温暖。',
    rating: 4,
  },
];

const teamMembers = [
  {
    name: '林美仪',
    role: '创始人 & 主笔',
    description: '资深护肤爱好者，拥有10年护肤经验，专注少妇肌肤管理研究。坚信科学护肤的力量，致力于用通俗易懂的语言传递专业的护肤知识。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20woman%20in%20her%2030s%20elegant%20blouse%20warm%20smile%20studio%20portrait%20on%20cream%20background%20soft%20lighting%20professional%20headshot&width=400&height=400&seq=team-01&orientation=squarish',
  },
  {
    name: '陈雅琪',
    role: '联合创始人 & 编辑',
    description: '两个孩子的妈妈，亲身经历孕期和产后肌肤变化，用真实体验结合专业知识，为新妈妈们提供最贴心的护肤指导。',
    image: 'https://readdy.ai/api/search-image?query=Asian%20woman%20in%20her%2030s%20with%20gentle%20smile%20natural%20makeup%20studio%20portrait%20cream%20background%20warm%20lighting%20professional%20headshot&width=400&height=400&seq=team-02&orientation=squarish',
  },
];

export default function AboutPage() {
  const [formStatus, setFormStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [formMessage, setFormMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = (formData.get('company_alt') as string || '').trim();
    if (honeypot) {
      setFormStatus('success');
      setFormMessage('感谢您的留言！我们会尽快与您联系。');
      form.reset();
      return;
    }

    setFormStatus('loading');
    setFormMessage('');

    try {
      formData.delete('company_alt');
      const params = new URLSearchParams();
      formData.forEach((value, key) => {
        params.append(key, value as string);
      });

      const response = await fetch('https://readdy.ai/api/form/d9u4isv8l97n3eas3ha0', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: params.toString(),
      });

      const responseText = await response.text();
      let parsed: any;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (response.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        setFormMessage('感谢您的留言！我们会尽快与您联系。');
        form.reset();
      } else if (serverMsg && (typeof serverMsg === 'string') && serverMsg.toLowerCase().includes('spam')) {
        setFormStatus('error');
        setFormMessage('提交失败，请稍后再试。');
      } else {
        setFormStatus('error');
        setFormMessage(typeof serverMsg === 'string' ? serverMsg : '提交失败，请稍后再试。');
      }
    } catch {
      setFormStatus('error');
      setFormMessage('网络错误，请检查您的连接后重试。');
    }
  };

  return (
    <>
      <title>关于我们 - 少妇护肤美容指南</title>
      <meta name="description" content="了解少妇护肤美容指南的品牌故事、专业团队和用户口碑。我们致力于为每一位少妇提供科学、温和、高效的护肤美容指导。" />
      <meta name="keywords" content="少妇护肤,关于我们,护肤指南,美容团队,联系方式" />
      <link rel="canonical" href="https://meirong01.github.io/about" />
      <meta property="og:title" content="关于我们 - 少妇护肤美容指南" />
      <meta property="og:description" content="了解少妇护肤美容指南的品牌故事、专业团队和用户口碑。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://meirong01.github.io/about" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="关于我们 - 少妇护肤美容指南" />
      <meta name="twitter:description" content="了解少妇护肤美容指南的品牌故事、专业团队和用户口碑。" />

      <Navbar />

      <main className="min-h-screen pt-20">
        <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: '首页', path: '/' },
              { label: '关于我们' },
            ]}
          />
        </div>

        {/* Hero */}
        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
            <div className="max-w-3xl">
              <h1 className="font-heading text-3xl md:text-4xl font-semibold text-foreground-900 mb-5 leading-tight">
                关于少妇护肤指南
              </h1>
              <p className="text-foreground-600 leading-relaxed text-base md:text-lg">
                我们是一群热爱护肤、关注女性成长的普通女性。因为我们自己就是少妇，所以我们比任何人都更理解少妇肌肤的需求和困扰。这个平台，源于我们自己对科学护肤的执着和对美好生活的追求。
              </p>
            </div>
          </div>
        </section>

        {/* Mission */}
        <section className="py-14 md:py-18 bg-background-100">
          <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-10">
              <div className="text-center p-8 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-heart-line text-2xl"></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">我们的使命</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  用科学与温暖，陪伴每一位少妇走过肌肤的每一个阶段。不贩卖焦虑，只传递真实有效的护肤知识。
                </p>
              </div>
              <div className="text-center p-8 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-lightbulb-line text-2xl"></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">我们的理念</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  科学护肤、温和有效、内外兼修。拒绝过度护肤，拒绝盲目跟风，让每一位少妇都能找到最适合自己的护肤方式。
                </p>
              </div>
              <div className="text-center p-8 rounded-xl bg-background-50 border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600">
                  <i className="ri-team-line text-2xl"></i>
                </div>
                <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-3">我们的团队</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  由资深护肤爱好者和专业内容创作者组成。我们既是内容的创作者，也是内容的实践者，每一个护肤建议都经过亲身体验。
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Team */}
        <section className="py-14 md:py-18 bg-background-50">
          <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
                我们的团队
              </h2>
              <p className="text-foreground-600 text-sm">因为亲身经历，所以更懂你</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 md:gap-10 max-w-3xl mx-auto">
              {teamMembers.map((member) => (
                <div key={member.name} className="text-center">
                  <div className="w-28 h-28 md:w-32 md:h-32 mx-auto mb-5 rounded-full overflow-hidden">
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-full h-full object-cover"
                      title={`${member.name} - ${member.role}`}
                    />
                  </div>
                  <h3 className="font-heading text-lg font-semibold text-foreground-900">{member.name}</h3>
                  <p className="text-sm text-primary-600 font-medium mb-3">{member.role}</p>
                  <p className="text-sm text-foreground-600 leading-relaxed">{member.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Testimonials */}
        <section className="py-14 md:py-18 bg-background-100">
          <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
                用户口碑
              </h2>
              <p className="text-foreground-600 text-sm">来自真实用户的护肤反馈</p>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              {testimonials.map((t, idx) => (
                <div key={idx} className="bg-background-50 rounded-xl p-6 border border-background-200/70">
                  <div className="flex items-center gap-0.5 mb-4">
                    {Array.from({ length: t.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                    ))}
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed mb-4">{t.content}</p>
                  <div>
                    <p className="text-sm font-medium text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-500">{t.age}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Form */}
        <section className="py-14 md:py-18 bg-background-50">
          <div className="w-full max-w-2xl mx-auto px-4 md:px-6">
            <div className="text-center mb-10">
              <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-3">
                联系我们
              </h2>
              <p className="text-foreground-600 text-sm">
                有任何护肤疑问或合作建议？我们期待听到你的声音。
              </p>
            </div>

            <form
              onSubmit={handleSubmit}
              data-readdy-form
              className="bg-background-100 rounded-xl p-6 md:p-8 border border-background-200/70"
            >
              <input
                type="text"
                name="company_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="hp-field"
              />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    姓名 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    required
                    className="w-full px-4 py-3 rounded-lg bg-background-50 border border-background-200/70 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-all"
                    placeholder="请输入您的姓名"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-foreground-700 mb-1.5">
                    邮箱 <span className="text-primary-500">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    required
                    className="w-full px-4 py-3 rounded-lg bg-background-50 border border-background-200/70 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-all"
                    placeholder="请输入您的邮箱"
                  />
                </div>
              </div>
              <div className="mb-4">
                <label htmlFor="subject" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  主题
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  className="w-full px-4 py-3 rounded-lg bg-background-50 border border-background-200/70 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-all"
                  placeholder="请输入主题"
                />
              </div>
              <div className="mb-6">
                <label htmlFor="message" className="block text-sm font-medium text-foreground-700 mb-1.5">
                  留言内容 <span className="text-primary-500">*</span>
                </label>
                <textarea
                  id="message"
                  name="message"
                  required
                  maxLength={500}
                  rows={5}
                  className="w-full px-4 py-3 rounded-lg bg-background-50 border border-background-200/70 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-200 transition-all resize-none"
                  placeholder="请输入您的留言内容（最多500字）"
                ></textarea>
              </div>
              <button
                type="submit"
                disabled={formStatus === 'loading'}
                className="w-full py-3.5 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-all duration-300 whitespace-nowrap text-sm disabled:opacity-60 cursor-pointer"
              >
                {formStatus === 'loading' ? '提交中...' : '发送留言'}
              </button>
              {formMessage && (
                <p
                  className={`mt-4 text-sm text-center ${
                    formStatus === 'success' ? 'text-emerald-600' : 'text-red-500'
                  }`}
                >
                  {formMessage}
                </p>
              )}
            </form>
          </div>
        </section>
      </main>

      <Footer />
      <ScrollToTop />
    </>
  );
}